import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  Form,
  Input,
  Row,
  Col,
  Descriptions,
  Tag,
  Divider,
  Button,
  message,
  Modal,
  Spin,
  Popconfirm,
  Image,
} from 'antd'
import { JobService, HomeService, InformfixService } from '../../../services'
import { number } from 'prop-types'
import { Moment } from '../../../helpers'
import { inject, observer } from 'mobx-react'
import './style.scss'
import { JobDateTime } from '../JobDateTime'
import { JobTechnichian } from '../JobTechnichian'
import { JobStatus } from '../JobStatus'
import {
  CameraFilled,
  CameraOutlined,
  SendOutlined,
  ThunderboltOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { JobDueDate } from '../JobDueDate'
import { JobGallery } from '../JobGallery'
import { JobImageUpload } from '../JobImageUpload'
import { JobSignature } from '../job-signature'
import { Fragment } from 'react'
import InformView from '../../informfix/inform-view'
import { Config } from '../../../config'
import local from 'antd/es/date-picker/locale/th_TH'
import ButtonGroup from 'antd/lib/button/button-group'
import { Radio, Tabs } from 'antd'
const TextArea = Input.TextArea
const formatTime = 'HH:mm'

@inject('informStore')
@observer
class JobView extends React.Component {
  constructor() {
    super()
    this.state = {
      keys: [],
      homes: [],
      home: {},
      loading: false,
      disabledSelectHome: true,
      jobId: number,
      currentTime: '',
      errors: {},
      items: [],
      visibleModalUpload: false,
      visibleModalInform: false,
      visibleModalSig: false,
      defaultActiveKey: 'detail',
    }

    this.formRef = React.createRef()
  }

  componentWillMount() {
    this.setState({
      jobId: this.props.editId,
    })
  }
  componentDidMount() {}

  getHome = (homeId) => {
    HomeService.view(homeId)
      .then((rs) => {
        if (rs) {
          this.setState({ home: rs.data['data'] })
        }
      })
      .catch((err) => this.setState({}))
  }
  getJob = (id) => {
    JobService.view(id)
      .then((rs) => {
        if (rs) {
          this.props.informStore.setJob(rs.data.data)
          console.log('jobforview', this.props.informStore.getJob)
        }
      })
      .catch((err) => this.setState({}))
  }
  viewInform = (id) => {
    this.setState({
      visibleModalInform: true,
    })

    InformfixService.view(id)
      .then((rs) => {
        if (rs.data.data) {
          this.props.informStore.setItem(rs.data.data)
        }
      })
      .catch((err) => this.props.informStore.setItem([]))

    InformfixService.getJobs(id)
      .then((rs) => {
        if (rs.data.data) {
          this.props.informStore.setJobItems(rs.data.data)
        }
      })
      .catch((err) => {
        this.props.informStore.setJobItems([])
      })
  }

  hideModalViewInform = () => {
    this.setState({
      visibleModalInform: false,
    })
  }

  setVisibleModalUpload = (value) => {
    this.setState({
      visibleModalUpload: value,
    })
  }

  setVisibleModalSig = (value) => {
    this.setState({
      visibleModalSig: value,
    })
  }

  confirmStartWork = () => {
    JobService.start(this.props.job.id)
      .then((rs) => {
        if (rs) {
          this.props.informStore.setJob(rs.data.data)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  confirmSendJob = () => {
    JobService.sendJob(this.props.job.id)
      .then((rs) => {
        if (rs) {
          this.props.informStore.setJob(rs.data.data)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  onChangeTab = (tab) => {
    this.setState({
      defaultActiveKey: tab,
    })
  }

  render() {
    const { loading, inform, visibleModalSig } = this.state
    const { job } = this.props

    const canDelete = this.props.canDelete ? this.props.canDelete : false

    // แสดงวันที่ from unix timestamp
    const showTimeFromUnix = (datetime) => {
      let date = Moment.unix(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }
    // แสดงวันที่
    const showTime = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }

    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 7 },
              md: { span: 7 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 17 },
              md: { span: 17 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 17, offset: 7 },
              sm: { span: 17, offset: 7 },
            },
          }
        : null

    return (
      <div id="job-view">
        {job ? (
          <React.Fragment>
            <h3>{job ? job.list : null}</h3>
            <JobDueDate data={job} />
            <p>{job ? job.description : null}</p>
            <CopyToClipboard
              options={{ message: '' }}
              onCopy={() => message.success('ก๊อปปี้แล้ว')}
              text={'http://job.zsignservice.com/?id=' + job.id}
            >
              <div className="copy-box">
                ลิังค์สำหรับส่งให้: ผู้รับเหมา/ช่างที่ไม่ได้เป็นพนักงานบริษัท
                อัพโหลดรูปภาพ/กดส่งงาน
                <Input
                  type="text"
                  ref="publicLink"
                  value={'http://job.zsignservice.com/?id=' + job.id}
                  readOnly
                />
              </div>
            </CopyToClipboard>

            <div style={{ marginTop: 5, marginBottom: 5 }}>
              <ButtonGroup>
                {/* แสดงปุ่มเริ่มทำงาน */}
                {job.job_status == Config.job.status.OPEN.value &&
                job.start_job_at < 1 &&
                job.send_job_at < 1 ? (
                  <>
                    <Popconfirm
                      placement="topRight"
                      title={'ยืนยันเริ่มทำงาน #' + job.id + ' ?'}
                      onConfirm={() => this.confirmStartWork()}
                      okText="ใช่"
                      cancelText="ไม่ใช่"
                    >
                      <Button
                        icon={<ThunderboltOutlined />}
                        type="default"
                        size="medium"
                        style={{
                          backgroundColor: 'blue',
                          color: '#ffffff',
                        }}
                      >
                        กดรับงาน/เริ่มทำงาน
                      </Button>
                    </Popconfirm>
                  </>
                ) : null}
                <Button
                  type="text"
                  key={`btn__camera`}
                  icon={<CameraFilled style={{ color: '#001f40' }} />}
                  size="medium"
                  onClick={() => {
                    this.setVisibleModalUpload(true)
                  }}
                >
                  ถ่ายรูป
                </Button>
                {/* แสดงปุ่มส่งงาน */}
                {job.send_job_at < 1 || !job.send_job_at ? (
                  <>
                    <Button
                      icon={<SendOutlined />}
                      block
                      type="default"
                      size="medium"
                      style={{
                        backgroundColor: 'green',
                        color: '#ffffff',
                      }}
                      onClick={() => this.setVisibleModalSig(true)}
                    >
                      กดส่งงาน
                    </Button>
                  </>
                ) : null}
              </ButtonGroup>
            </div>

            <Tabs
              activeKey={this.state.defaultActiveKey}
              size="small"
              tabPosition="top"
              onChange={this.onChangeTab}
              items={[
                {
                  label: `รายละเอียดงาน`,
                  key: 'detail',

                  children: (
                    <>
                      <Descriptions
                        bordered
                        column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                        title=""
                        labelStyle={{
                          fontWeight: 'bold',
                        }}
                      >
                        <Descriptions.Item label="สถานที่">
                          {job && job.home ? (
                            <React.Fragment>
                              {job.project ? (
                                <Tag>{job.project.name}</Tag>
                              ) : null}
                              <div>
                                {job.home ? (
                                  <span>เลขที่ {job.home.home_no}</span>
                                ) : null}
                                {job.home ? (
                                  <span>
                                    &nbsp;&nbsp;แปลง {job.home.plan_no}
                                  </span>
                                ) : null}
                              </div>
                            </React.Fragment>
                          ) : null}
                        </Descriptions.Item>
                        <Descriptions.Item label="ตั้งแต่เวลา">
                          <JobDateTime
                            datetime={job.start_time}
                            jobStatus={job.job_status}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="ถึงเวลา">
                          <JobDateTime
                            datetime={job.end_time}
                            jobStatus={job.end_time}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="หมายเลข/ID">
                          <strong>{job.id}</strong>
                        </Descriptions.Item>
                        <Descriptions.Item label="สถานะ">
                          <JobStatus
                            name={job.jobStatusName}
                            statusId={job.status_id}
                          />
                        </Descriptions.Item>
                        <Descriptions.Item label="หมวดงาน">
                          {job.group ? job.group.name : null}
                        </Descriptions.Item>
                        <Descriptions.Item label="ผู้รับผิดชอบงาน">
                          {job.responsible_name ? job.responsible_name : null}
                        </Descriptions.Item>
                        <Descriptions.Item label="ช่าง">
                          <Fragment>
                            <JobTechnichian technicians={job.technicians} />
                          </Fragment>
                        </Descriptions.Item>

                        <Descriptions.Item label="วันที่โอน">
                          {job.home && job.home.warrantyExpired ? (
                            <>
                              <div>
                                {Moment(
                                  job.home.warrantyExpired.transfer_date,
                                ).format('ll')}
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="วันที่หมดประกัน(1 ปี)">
                          {job.home && job.home.warrantyExpired ? (
                            <>
                              <div>
                                {job.home.warrantyExpired['1y']
                                  ? Moment(
                                      job.home.warrantyExpired['1y'],
                                    ).format('ll')
                                  : ''}
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="วันที่หมดประกัน(5 ปี)">
                          {job.home && job.home.warrantyExpired ? (
                            <>
                              <div>
                                {job.home.warrantyExpired['5y']
                                  ? Moment(
                                      job.home.warrantyExpired['5y'],
                                    ).format('ll')
                                  : ''}
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="ใบแจ้งซ่อมอ้างอิง">
                          {job.informFix ? (
                            <Button
                              type="info"
                              onClick={() => this.viewInform(job.inform_fix_id)}
                            >{`${job.informFix.id}  (${job.informFix.code})`}</Button>
                          ) : (
                            '-ไม่ได้ระบุ-'
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="บันทึกเมื่อ">
                          {job.createdBy ? (
                            <>
                              {Moment.unix(job.created_at).format('lll')}
                              {job.createdBy &&
                              job.createdBy.personnel !== undefined ? (
                                <div>
                                  {job.createdBy.personnel.firstname_th +
                                    '  ' +
                                    job.createdBy.personnel.lastname_th}
                                </div>
                              ) : (
                                ''
                              )}
                            </>
                          ) : (
                            '-ไม่ได้ระบุ-'
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="ลายเซ็นต์ลูกค้า">
                          {job.signatureCustomer ? (
                            <>
                              <img
                                src={job.signatureCustomer}
                                className=""
                                style={{
                                  width: 200,
                                }}
                              />
                              <div>
                                {job.send_job_at > 0 &&
                                Moment.unix(job.send_job_at).isValid()
                                  ? Moment.unix(job.send_job_at).format('lll')
                                  : ''}
                              </div>
                            </>
                          ) : (
                            '-'
                          )}
                        </Descriptions.Item>
                      </Descriptions>
                    </>
                  ),
                },
                {
                  label: `รูปภาพ`,
                  key: 'image',
                  children: (
                    <>
                      {/* <div align="left">
                        <Button
                          type="link"
                          key={`btn__camera`}
                          icon={
                            <CameraFilled
                              style={{ fontSize: '24px', color: '#001f40' }}
                            />
                          }
                          size="medium"
                          onClick={() => {
                            this.setVisibleModalUpload(true)
                          }}
                        >
                          ถ่ายรูป
                        </Button>
                      </div> */}

                      <JobGallery
                        canDelete={canDelete}
                        beforeImages={job.beforeImages}
                        afterImages={job.afterImages}
                        onDeleteBeforeImages={(item) => {
                          JobService.deleteFile(item.id).then(() => {
                            message.success('ลบรูปภาพเรียบร้อย')
                            this.getJob(job.id)
                          })
                        }}
                        onDeleteAfterImages={(item) => {
                          JobService.deleteFile(item.id).then(() => {
                            message.success('ลบรูปภาพเรียบร้อย')
                            this.getJob(job.id)
                          })
                        }}
                      />
                    </>
                  ),
                },
                {
                  label: job.informFix
                    ? `ใบแจ้งซ่อม ${job.informFix.code}`
                    : `ใบแจ้งซ่อม`,
                  key: 'inform',
                  children: (
                    <>
                      {job.informFix ? (
                        <>
                          {job.informFix.description}
                          <Descriptions
                            bordered={true}
                            column={{
                              xxl: 2,
                              xl: 2,
                              lg: 2,
                              md: 2,
                              sm: 1,
                              xs: 1,
                            }}
                            labelStyle={{
                              fontWeight: 'bold',
                            }}
                            contentStyle={{}}
                          >
                            <Descriptions.Item label="เลขที่">
                              {job.informFix.code}
                            </Descriptions.Item>
                            <Descriptions.Item label="สถานะ">
                              {job.informFix.workStatusName}
                            </Descriptions.Item>

                            <Descriptions.Item label="ผู้แจ้ง">
                              {job.informFix.informer}
                              <div> ({job.informFix.date_inform_string})</div>
                            </Descriptions.Item>
                            <Descriptions.Item label="เบอร์ติดต่อ">
                              {job.informFix.contact_phone}
                            </Descriptions.Item>
                          </Descriptions>
                          {job.informFix.images ? (
                            <div style={{ background: 'black' }}>
                              <span style={{ color: 'yellow' }}>
                                คลิ๊กที่รูป.. เพื่อดูแบบขยาย
                              </span>
                              <Image.PreviewGroup>
                                <Row gutter={8}>
                                  {job.informFix.images.map((i, k) => (
                                    <Col span={6}>
                                      <Image
                                        src={i.url}
                                        style={{
                                          margin: '3px',
                                        }}
                                      />
                                    </Col>
                                  ))}
                                </Row>
                              </Image.PreviewGroup>
                            </div>
                          ) : null}
                        </>
                      ) : null}
                    </>
                  ),
                },
              ]}
            />

            <Divider />
            <Row gutter={8}>
              {job.start_job_at ? (
                <Col>
                  <div className="box-start-job">
                    <UserOutlined /> {job.start_job_user}
                    <div>
                      กดเริ่มทำงาน {Moment.unix(job.start_job_at).format('lll')}{' '}
                    </div>
                  </div>
                </Col>
              ) : null}

              {job.send_job_at > 0 ? (
                <Col>
                  <div className="box-send-job">
                    <UserOutlined /> {job.send_job_user}
                    <div>
                      กดส่งงาน{' '}
                      {Moment.unix(job.send_job_at)
                        .utc(7)
                        .format('lll')}
                    </div>
                  </div>
                </Col>
              ) : null}
            </Row>
          </React.Fragment>
        ) : null}

        {/* ///////////////////// ส่งงานและลานเซ็นต์ ////////////////////////// */}
        {visibleModalSig && !job.send_job_at ? (
          <JobSignature
            key={'sigcomponent' + job.id}
            job={job}
            visible={visibleModalSig}
            onClose={() => this.setVisibleModalSig(false)}
            canSendJob={true}
            onSave={(data) => {
              this.getJob(job.id)
            }}
            onSendJob={(data) => {
              this.getJob(job.id)
              this.setVisibleModalSig(false)
            }}
          />
        ) : (
          ''
        )}

        {/* ////////////// START Modal VIEW /////////// */}
        <Modal
          key="modal-view-inform"
          title="ดูรายละเอียดใบแจ้งซ่อม"
          bodyStyle={{
            padding: '7px',
            backgroundColor: '#222222',
            color: '#ffffff',
          }}
          width={960}
          open={this.state.visibleModalInform}
          cancelText="ปิดหน้าต่าง"
          maskClosable
          style={{ top: 10 }}
          onCancel={this.hideModalViewInform}
          footer=""
          destroyOnClose
        >
          {job && this.state.visibleModalInform ? (
            <InformView
              itemId={job.inform_fix_id}
              // home={homeDetail}
              // photos={photos}
              item={this.props.informStore.getItem}
              jobs={this.props.informStore.getJobItems}
              // jobStatuses={this.state.listJobStatus}
              // hideModal={this.hideModalView}
            />
          ) : (
            <Spin />
          )}
        </Modal>
        {/* ////////////// END Modal VIEW  /////////// */}

        {this.state.visibleModalUpload ? (
          <>
            {' '}
            <JobImageUpload
              jobId={job.id}
              visible={this.state.visibleModalUpload}
              onUpload={(data) => {
                this.setState({
                  defaultActiveKey: 'image',
                })
                console.log('active', this.state.defaultActiveKey)
                console.log('on upload', data)
                this.getJob(job.id)
                setTimeout(() => this.setVisibleModalUpload(false), 500)
              }}
              onCancel={() => {
                this.getJob(job.id)
                console.log('active', this.state.defaultActiveKey)
                setTimeout(() => this.setVisibleModalUpload(false), 500)
              }}
            />
          </>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default JobView
